import React from 'react';
import { AlertCircle, X } from 'lucide-react';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message, confirmText, cancelText, type = 'warning' }) => {
  if (!isOpen) return null;

  const bgColor = type === 'danger' ? 'bg-red-50' : 'bg-blue-50';
  const iconColor = type === 'danger' ? 'text-red-600' : 'text-blue-600';
  const buttonColor = type === 'danger' 
    ? 'bg-red-600 hover:bg-red-700' 
    : 'bg-primary-600 hover:bg-primary-700';

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className={`${bgColor} rounded-2xl shadow-2xl border-2 border-gray-200 max-w-md w-full mx-4 transform transition-all`}>
        <div className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div className={`p-3 rounded-full ${iconColor.replace('text-', 'bg-').replace('-600', '-100')}`}>
              <AlertCircle className={`h-6 w-6 ${iconColor}`} />
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-lg hover:bg-white/50"
              aria-label="Close"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          
          <h3 className="text-xl font-bold text-gray-900 mb-2">{title}</h3>
          <p className="text-gray-700 mb-6">{message}</p>
          
          <div className="flex gap-3 justify-end">
            <button
              onClick={onClose}
              className="px-6 py-2.5 bg-gray-200 text-gray-800 rounded-lg font-semibold hover:bg-gray-300 transition-colors"
            >
              {cancelText || 'Cancel'}
            </button>
            <button
              onClick={() => {
                onConfirm();
                onClose();
              }}
              className={`px-6 py-2.5 ${buttonColor} text-white rounded-lg font-semibold transition-colors`}
            >
              {confirmText || 'Confirm'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
